import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { Typography } from 'src/components';

const NoReimbursementData = ({ allZero = false }: { allZero?: boolean }) => {
  const header = allZero
    ? '"Why is there no reimbursement data?"'
    : '"Why is this payer missing?"';

  return (
    <div className="flex flex-col gap-2 justify-center items-center font-medium rounded-xl bg-neutral-100 p-4 w-full h-full">
      <Icon icon={faQuestionCircle} className="text-secondary" size="lg" />
      <Typography className="text-sm font-bold text-primary max-w-md text-center">
        {header}
      </Typography>
      <Typography className="text-sm text-primary max-w-md text-center">
        Due to claim adjudication and clearinghouse lag, MedScout may not have
        reimbursement information for all claims.
      </Typography>
    </div>
  );
};

export default NoReimbursementData;
